import { render, staticRenderFns } from "./TranslatorProposalModal.vue?vue&type=template&id=160d107e&scoped=true"
import script from "./TranslatorProposalModal.vue?vue&type=script&lang=js"
export * from "./TranslatorProposalModal.vue?vue&type=script&lang=js"
import style0 from "./TranslatorProposalModal.vue?vue&type=style&index=0&id=160d107e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160d107e",
  null
  
)

export default component.exports